import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

const MESSAGES = [
  'Amazing Instant Itinerary now available via NavMind',
  'AI-crafted day-by-day plans in minutes, not weeks',
  'One hidden gem in every city, hand-picked for your trip',
  'Real hotels, real contacts, honest pricing',
  'Your itinerary, your language — 20+ languages supported',
];

// Seamless marquee: the track holds two identical halves and scrolls exactly 50%,
// so the loop restarts invisibly. Headlines rotate naturally as the band scrolls.
// Pauses on hover and respects reduced-motion.
const NavMindTicker = () => {
  const half = (
    <>
      {MESSAGES.map((msg, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="text-sm font-semibold tracking-wide uppercase whitespace-nowrap">{msg}</span>
          <Sparkles className="w-3.5 h-3.5 mx-6 text-amber-900/60 shrink-0" />
        </span>
      ))}
    </>
  );

  return (
    <Link
      to="/instant-itinerary"
      data-testid="navmind-ticker"
      aria-label={MESSAGES[0]}
      className="group relative block overflow-hidden bg-amber-500 text-amber-950 border-y border-amber-600/40 hover:bg-amber-400 transition-colors"
    >
      <div className="flex w-max animate-marquee py-2.5 group-hover:[animation-play-state:paused] motion-reduce:animate-none">
        {half}
        {half}
      </div>
      {/* edge fades so text enters and leaves softly */}
      <span className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-amber-500 to-transparent group-hover:from-amber-400" />
      <span className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-amber-500 to-transparent group-hover:from-amber-400" />
    </Link>
  );
};

export default NavMindTicker;
